var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8998EDF9-8282-4703-841B-5E0089A778AA_sharp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.7877713%",
    y1: "80.2864889%",
    x2: "100%",
    y2: "31.4257407%",
    id: "back_sharp-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003DA5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 630,
    height: 353,
    rx: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.2%",
    y: "-5.9%",
    width: "110.5%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.29914253   0 0 0 0 0.575556979   0 0 0 0 1  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[New]-Customer-Portal---Desktop---Logins---Forgot-ID---Error---Help",
    transform: "translate(-597.000000, -370.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F8FA",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "illustration_login",
    transform: "translate(104.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(8.000000, 45.000000)",
    fill: "url(#back_sharp-1)",
    fillRule: "nonzero",
    opacity: 0.799999952
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.965305,319.061342 C491.797275,276.330591 502.479261,189.172784 460.96518,128.509657 C426.329651,77.9435887 362.642358,26.0043205 282.284694,10.8183448 C201.927029,-4.367631 131.603958,-4.28685454 101.176483,15.6649328 C76.2518503,32.0625555 87.8240014,54.8415192 95.6736423,74.2278712 C106.112856,100.076341 107.650414,120.67434 64.7606234,158.235397 C15.8015227,201.127701 2.52996485,217.282994 0.102240845,258.802098 C-1.92086249,292.566661 26.32166,337.963035 63.3849131,344.505929 C114.933586,353.552893 134.112606,329.643059 184.528341,313.487766 C224.990407,300.563531 253.071082,306.621766 289.810638,331.420142 C326.550195,356.218517 381.254909,381.663104 446.965305,319.061342 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "login_page_illustration_2",
    transform: "translate(63.000000, 90.000000)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.799999952,
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(405.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/chevron_left_24px",
    transform: "translate(192.000000, 34.000000)",
    fill: "#003DA5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-left",
    transform: "translate(8.166667, 2.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3059075,18.4445606 C11.8291309,18.9489267 11.8294389,19.7681504 11.3059075,20.2729621 C10.782992,20.7777738 9.93394723,20.7776252 9.41026185,20.2729621 C9.40718225,20.2699917 9.40487255,20.2670214 9.40210091,20.2639025 L9.39825142,20.2671699 L0.519774778,11.7036388 L0.523470294,11.7003714 C0.275562778,11.4658619 0.121890547,11.139717 0.121890547,10.7783735 C0.121582954,10.3729201 0.315597532,10.011131 0.619091764,9.77409671 L0.609852975,9.76548268 L9.48832962,1.20195158 L9.49217911,1.205516 C9.49495075,1.20239713 9.49726045,1.19972381 9.50034004,1.19690198 C10.0238714,0.691941766 10.8726082,0.691941766 11.3961396,1.19690198 C11.9193631,1.70126812 11.9193631,2.51989773 11.3961396,3.02530349 C11.3929061,3.02827385 11.3898265,3.03035309 11.3867469,3.03332345 L11.3902884,3.03688787 L3.36501396,10.7783735 L11.3011341,18.4329762 L11.2972846,18.436095 C11.2995943,18.4393624 11.3028279,18.4414417 11.3059075,18.4445606",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSharp);
export default __webpack_public_path__ + "static/media/back_sharp.06b340c7bf7ab5740849b836b55ad0dd.svg";
export { ForwardRef as ReactComponent };